import React, { useMemo, useState } from "react";
import RfmModalBase from "./RfmModalBase";

export default function RfmCreateTableModal({ open, onClose, zones = [], onCreate }) {
  const [number, setNumber] = useState("");
  const [zoneId, setZoneId] = useState(zones?.[0]?.id || "");
  const [chairs, setChairs] = useState(2);
  const [shape, setShape] = useState("square");
  const [w, setW] = useState(1);
  const [h, setH] = useState(1);

  const canSubmit = useMemo(() => zones.length > 0, [zones]);

  const submit = () => {
    if (!canSubmit) return;
    onCreate?.({
      number: number.trim() || null,
      name: number.trim() || `Mesa ${Date.now()}`,
      zone: zoneId || zones?.[0]?.id,
      chairs: Number(chairs) || 2,
      shape,
      gridW: Number(w) || 1,
      gridH: Number(h) || 1,
    });
    setNumber("");
    setChairs(2);
    setShape("square");
    setW(1);
    setH(1);
    onClose?.();
  };

  return (
    <RfmModalBase
      open={open}
      title="Nueva Mesa"
      onClose={onClose}
      footer={
        <>
          <div className="ord-footer">
            <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
              Cancelar
            </button>
            <button className="ord-btn ord-btn-primary" type="button" onClick={submit} disabled={!canSubmit}>
              <i className="bi bi-plus-lg" /> Crear
            </button>
          </div>
        </>
      }
    >
      {/* ======================================================================= */}
      <div className="off-x-form-group">
        <label className="off-x-form-label">Nombre de la Mesa</label>
        <input className="off-x-form-input" value={number} onChange={(e) => setNumber(e.target.value)} placeholder="Ej: 1, A1" />
      </div>
      {/* ======================================================================= */}

      <div className="off-x-form-group mt-4">
        <label className="off-x-form-label">Zona</label>
        <select className="off-x-form-input" value={zoneId} onChange={(e) => setZoneId(e.target.value)}>
          {zones.map((z) => (
            <option key={z.id} value={z.id}>
              {z.name}
            </option>
          ))}
        </select>
      </div>

      {/* ======================================================================= */}
      <div className="off-x-form-group mt-4">
        <label className="off-x-form-label">Número de Sillas</label>
        <div className="off-x-chair-selector">
          <button className="off-x-chair-btn" type="button" onClick={() => setChairs((v) => Math.max(1, v - 1))}>
            <i className="bi bi-dash" />
          </button>
          <span className="off-x-chair-count">{chairs}</span>
          <button className="off-x-chair-btn" type="button" onClick={() => setChairs((v) => Math.max(1, v + 1))}>
            <i className="bi bi-plus" />
          </button>
        </div>
      </div>
      {/* ======================================================================= */}
      <div className="off-x-form-group mt-4">
        <label className="off-x-form-label">Forma</label>
        <div className="off-x-shape-selector">
          {[
            { id: "square", label: "Cuadrada" },
            { id: "rectangle", label: "Rectangular" },
            { id: "round", label: "Redonda" },
          ].map((s) => (
            <div
              key={s.id}
              className={`off-x-shape-option shape-round ${s.id} ${shape === s.id ? "active" : ""}`}
              onClick={() => setShape(s.id)}
            >
              {s.label}
            </div>
          ))}
        </div>
      </div>
      {/* ======================================================================= */}
      <div className="off-x-form-group mt-4">
        <label className="off-x-form-label">Tamaño en Grid (celdas)</label>
        <div className="off-x-size-selector">
          <div className="off-x-size-group">
            <label>Ancho:</label>
            <input type="number" min={1} max={5} value={w} onChange={(e) => setW(e.target.value)} />
          </div>
          <div className="off-x-size-group">
            <label>Alto:</label>
            <input type="number" min={1} max={5} value={h} onChange={(e) => setH(e.target.value)} />
          </div>
        </div>
      </div>
    </RfmModalBase>
  );
}
